module.exports = (function(e) {
  var n = {};
  function t(r) {
    if (n[r]) return n[r].exports;
    var o = (n[r] = { i: r, l: !1, exports: {} });
    return e[r].call(o.exports, o, o.exports, t), (o.l = !0), o.exports;
  }
  return (
    (t.m = e),
    (t.c = n),
    (t.d = function(e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, { enumerable: !0, get: r });
    }),
    (t.r = function(e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (t.t = function(e, n) {
      if ((1 & n && (e = t(e)), 8 & n)) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (
        (t.r(r),
        Object.defineProperty(r, "default", { enumerable: !0, value: e }),
        2 & n && "string" != typeof e)
      )
        for (var o in e)
          t.d(
            r,
            o,
            function(n) {
              return e[n];
            }.bind(null, o),
          );
      return r;
    }),
    (t.n = function(e) {
      var n =
        e && e.__esModule
          ? function() {
              return e.default;
            }
          : function() {
              return e;
            };
      return t.d(n, "a", n), n;
    }),
    (t.o = function(e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }),
    (t.p = ""),
    t((t.s = 5))
  );
})([
  function(e, n) {
    e.exports = require("react");
  },
  function(e, n, t) {
    var r = t(2),
      o = t(3);
    "string" == typeof (o = o.__esModule ? o.default : o) &&
      (o = [[e.i, o, ""]]);
    var i = { insert: "head", singleton: !1 },
      a = (r(o, i), o.locals ? o.locals : {});
    e.exports = a;
  },
  function(e, n, t) {
    "use strict";
    var r,
      o = function() {
        return (
          void 0 === r &&
            (r = Boolean(window && document && document.all && !window.atob)),
          r
        );
      },
      i = (function() {
        var e = {};
        return function(n) {
          if (void 0 === e[n]) {
            var t = document.querySelector(n);
            if (
              window.HTMLIFrameElement &&
              t instanceof window.HTMLIFrameElement
            )
              try {
                t = t.contentDocument.head;
              } catch (e) {
                t = null;
              }
            e[n] = t;
          }
          return e[n];
        };
      })(),
      a = [];
    function l(e) {
      for (var n = -1, t = 0; t < a.length; t++)
        if (a[t].identifier === e) {
          n = t;
          break;
        }
      return n;
    }
    function c(e, n) {
      for (var t = {}, r = [], o = 0; o < e.length; o++) {
        var i = e[o],
          c = n.base ? i[0] + n.base : i[0],
          u = t[c] || 0,
          s = "".concat(c, " ").concat(u);
        t[c] = u + 1;
        var d = l(s),
          f = { css: i[1], media: i[2], sourceMap: i[3] };
        -1 !== d
          ? (a[d].references++, a[d].updater(f))
          : a.push({ identifier: s, updater: v(f, n), references: 1 }),
          r.push(s);
      }
      return r;
    }
    function u(e) {
      var n = document.createElement("style"),
        r = e.attributes || {};
      if (void 0 === r.nonce) {
        var o = t.nc;
        o && (r.nonce = o);
      }
      if (
        (Object.keys(r).forEach(function(e) {
          n.setAttribute(e, r[e]);
        }),
        "function" == typeof e.insert)
      )
        e.insert(n);
      else {
        var a = i(e.insert || "head");
        if (!a)
          throw new Error(
            "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.",
          );
        a.appendChild(n);
      }
      return n;
    }
    var s,
      d =
        ((s = []),
        function(e, n) {
          return (s[e] = n), s.filter(Boolean).join("\n");
        });
    function f(e, n, t, r) {
      var o = t
        ? ""
        : r.media
        ? "@media ".concat(r.media, " {").concat(r.css, "}")
        : r.css;
      if (e.styleSheet) e.styleSheet.cssText = d(n, o);
      else {
        var i = document.createTextNode(o),
          a = e.childNodes;
        a[n] && e.removeChild(a[n]),
          a.length ? e.insertBefore(i, a[n]) : e.appendChild(i);
      }
    }
    function p(e, n, t) {
      var r = t.css,
        o = t.media,
        i = t.sourceMap;
      if (
        (o ? e.setAttribute("media", o) : e.removeAttribute("media"),
        i &&
          btoa &&
          (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(
            btoa(unescape(encodeURIComponent(JSON.stringify(i)))),
            " */",
          )),
        e.styleSheet)
      )
        e.styleSheet.cssText = r;
      else {
        for (; e.firstChild; ) e.removeChild(e.firstChild);
        e.appendChild(document.createTextNode(r));
      }
    }
    var m = null,
      h = 0;
    function v(e, n) {
      var t, r, o;
      if (n.singleton) {
        var i = h++;
        (t = m || (m = u(n))),
          (r = f.bind(null, t, i, !1)),
          (o = f.bind(null, t, i, !0));
      } else
        (t = u(n)),
          (r = p.bind(null, t, n)),
          (o = function() {
            !(function(e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            })(t);
          });
      return (
        r(e),
        function(n) {
          if (n) {
            if (
              n.css === e.css &&
              n.media === e.media &&
              n.sourceMap === e.sourceMap
            )
              return;
            r((e = n));
          } else o();
        }
      );
    }
    e.exports = function(e, n) {
      (n = n || {}).singleton ||
        "boolean" == typeof n.singleton ||
        (n.singleton = o());
      var t = c((e = e || []), n);
      return function(e) {
        if (
          ((e = e || []),
          "[object Array]" === Object.prototype.toString.call(e))
        ) {
          for (var r = 0; r < t.length; r++) {
            var o = l(t[r]);
            a[o].references--;
          }
          for (var i = c(e, n), u = 0; u < t.length; u++) {
            var s = l(t[u]);
            0 === a[s].references && (a[s].updater(), a.splice(s, 1));
          }
          t = i;
        }
      };
    };
  },
  function(e, n, t) {
    (n = t(4)(!1)).push([
      e.i,
      ".slider__wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  user-select: none;\r\n  overflow: hidden;\r\n}\r\n\r\n.slider__stick {\r\n  position: absolute;\r\n  width: 3px;\r\n  height: 100%;\r\n  background-color: red;\r\n}\r\n\r\n.slider__stick:hover {\r\n  cursor: ew-resize;\r\n}\r\n\r\n.slider__handle {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate3d(-50%, -50%, 0);\r\n}\r\n\r\n.slider__container {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.label__text {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate3d(0, -50%, 0);\r\n  padding: 6px 12px;\r\n  white-space: nowrap;\r\n  border-radius: 4px;\r\n  color: rgb(240, 240, 240);\r\n  box-shadow: 0px 0px 20px -9px rgba(0, 0, 0, 0.59);\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.label__left {\r\n  left: 8px;\r\n}\r\n\r\n.label__right {\r\n  right: 8px;\r\n}\r\n\r\n.placeholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  background: #f6f7f8;\r\n  background-image: linear-gradient(\r\n    to right,\r\n    #f6f6fa 0%,\r\n    #edeef1 30%,\r\n    #edeef1 35%,\r\n    #f6f7f8 100%\r\n  );\r\n  background-repeat: no-repeat;\r\n\r\n  animation-duration: 1.25s;\r\n  animation-fill-mode: forwards;\r\n  animation-iteration-count: infinite;\r\n  animation-name: placeholderAnimation;\r\n  animation-timing-function: linear;\r\n}\r\n\r\n@keyframes placeholderAnimation {\r\n  0% {\r\n    background-position: -50px 0;\r\n  }\r\n\r\n  100% {\r\n    background-position: 1100px 0;\r\n  }\r\n}\r\n\r\n.custom-placeholder__wrapper {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 100%;\r\n  white-space: nowrap;\r\n}\r\n",
      "",
    ]),
      (e.exports = n);
  },
  function(e, n, t) {
    "use strict";
    e.exports = function(e) {
      var n = [];
      return (
        (n.toString = function() {
          return this.map(function(n) {
            var t = (function(e, n) {
              var t = e[1] || "",
                r = e[3];
              if (!r) return t;
              if (n && "function" == typeof btoa) {
                var o =
                    ((a = r),
                    (l = btoa(unescape(encodeURIComponent(JSON.stringify(a))))),
                    (c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(
                      l,
                    )),
                    "/*# ".concat(c, " */")),
                  i = r.sources.map(function(e) {
                    return "/*# sourceURL="
                      .concat(r.sourceRoot || "")
                      .concat(e, " */");
                  });
                return [t]
                  .concat(i)
                  .concat([o])
                  .join("\n");
              }
              var a, l, c;
              return [t].join("\n");
            })(n, e);
            return n[2] ? "@media ".concat(n[2], " {").concat(t, "}") : t;
          }).join("");
        }),
        (n.i = function(e, t, r) {
          "string" == typeof e && (e = [[null, e, ""]]);
          var o = {};
          if (r)
            for (var i = 0; i < this.length; i++) {
              var a = this[i][0];
              null != a && (o[a] = !0);
            }
          for (var l = 0; l < e.length; l++) {
            var c = [].concat(e[l]);
            (r && o[c[0]]) ||
              (t &&
                (c[2]
                  ? (c[2] = "".concat(t, " and ").concat(c[2]))
                  : (c[2] = t)),
              n.push(c));
          }
        }),
        n
      );
    };
  },
  function(e, n, t) {
    "use strict";
    t.r(n);
    var r = t(0),
      o = t.n(r);
    t(1);
    var i,
      a = function(e) {
        var n = e.backgroundColor,
          t = e.color;
        return o.a.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "32",
            height: "32",
            fill: "none",
            viewBox: "0 0 32 32",
          },
          o.a.createElement("circle", { cx: "16", cy: "16", r: "16", fill: n }),
          o.a.createElement("path", {
            fill: t,
            d: "M8.8 16l5.067 5.429V10.57L8.8 16z",
          }),
          o.a.createElement("path", {
            stroke: t,
            d: "M13.867 10.286v.285m0 0V21.43L8.8 16l5.067-5.429z",
          }),
          o.a.createElement("path", {
            fill: t,
            d: "M23.733 16l-5.066 5.429V10.57L23.733 16z",
          }),
          o.a.createElement("path", {
            stroke: t,
            d: "M18.667 10.286v.285m0 0V21.43L23.733 16l-5.066-5.429z",
          }),
        );
      };
    function l(e, n) {
      return (
        (function(e) {
          if (Array.isArray(e)) return e;
        })(e) ||
        (function(e, n) {
          if (
            !(
              Symbol.iterator in Object(e) ||
              "[object Arguments]" === Object.prototype.toString.call(e)
            )
          )
            return;
          var t = [],
            r = !0,
            o = !1,
            i = void 0;
          try {
            for (
              var a, l = e[Symbol.iterator]();
              !(r = (a = l.next()).done) &&
              (t.push(a.value), !n || t.length !== n);
              r = !0
            );
          } catch (e) {
            (o = !0), (i = e);
          } finally {
            try {
              r || null == l.return || l.return();
            } finally {
              if (o) throw i;
            }
          }
          return t;
        })(e, n) ||
        (function() {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance",
          );
        })()
      );
    }
    function c(e) {
      var n = e.image1,
        t = e.image2,
        o = e.alt1,
        c = void 0 === o ? "alt1" : o,
        u = e.alt2,
        s = void 0 === u ? "alt2" : u,
        d = e.sliderColor,
        f = void 0 === d ? "red" : d,
        p = e.sliderWidth,
        m = void 0 === p ? 3 : p,
        h = e.sliderInitialPosition,
        v = void 0 === h ? 0.5 : h,
        g = e.onSlide,
        b = e.onSlideEnd,
        w = e.handleBackgroundColor,
        y = void 0 === w ? "white" : w,
        _ = e.handleColor,
        E = void 0 === _ ? "red" : _,
        x = e.showHandle,
        S = void 0 === x || x,
        L = e.customHandle,
        C = void 0 === L ? null : L,
        j = e.leftLabelText,
        k = void 0 === j ? null : j,
        M = e.rightLabelText,
        N = void 0 === M ? null : M,
        O = e.onLoadFirstImage,
        T = e.onLoadSecondImage,
        A = e.onErrorFirstImage,
        R = e.onErrorSecondImage,
        I = e.showPlaceholder,
        P = void 0 === I || I,
        B = e.customPlaceholder,
        F = void 0 === B ? null : B,
        z = e.animate,
        X = void 0 !== z && z,
        U = e.animationCycleDuration,
        D = void 0 === U ? 5e3 : U,
        H = l(r.useState(null), 2),
        V = H[0],
        q = H[1],
        J = l(r.useState(!1), 2),
        W = J[0],
        G = J[1],
        K = r.useRef(null),
        Q = l(r.useState({ width: 0, height: 0 }), 2),
        Y = Q[0],
        Z = Q[1],
        $ = l(r.useState(!1), 2),
        ee = $[0],
        ne = $[1],
        te = l(r.useState(!1), 2),
        re = te[0],
        oe = te[1],
        ie = r.useRef(null);
      r.useEffect(
        function() {
          var e = 1,
            n = 0;
          if (K && K.current) {
            var t = K.current.getBoundingClientRect(),
              r = t.width,
              o = t.height;
            Z({ width: r, height: o }),
              q(r * v),
              X &&
                ((ie.current = r * v),
                (e = Math.round((r / D) * 16.6 * 100) / 100),
                (n = r),
                (function t() {
                  (i = requestAnimationFrame(t)),
                    null !== ie.current &&
                      (ie.current >= n
                        ? (e *= -1)
                        : ie.current <= 0 && (e *= -1),
                      q(ie.current + e),
                      (ie.current += e));
                })());
          }
        },
        [X, D, v],
      ),
        r.useEffect(
          function() {
            function e(e) {
              G(!1), b && b();
            }
            function n(e) {
              if (K && K.current && W) {
                var n = K.current.getBoundingClientRect(),
                  t = n.left,
                  r = n.width;
                g && g(),
                  e.pageX - t < 0
                    ? q(0 - m / 2)
                    : e.pageX > t + r
                    ? q(r - m / 2)
                    : q(e.pageX - t);
              }
            }
            function t(e) {
              if (K && K.current && W) {
                var n = K.current.getBoundingClientRect(),
                  t = n.left,
                  r = n.width;
                e.touches[0].pageX - t < 0
                  ? q(0 - m / 2)
                  : e.touches[0].pageX > t + r
                  ? q(r - m / 2)
                  : q(e.touches[0].pageX - t);
              }
            }
            return (
              document.addEventListener("mouseup", e),
              document.addEventListener("touchend", e),
              document.addEventListener("mousemove", n),
              document.addEventListener("touchmove", t),
              function() {
                document.removeEventListener("mouseup", e),
                  document.removeEventListener("touchend", e),
                  document.removeEventListener("mousemove", n),
                  document.removeEventListener("touchmove", t);
              }
            );
          },
          [W, g, b, m],
        );
      var ae = function(e) {
        e.stopPropagation(), e.preventDefault(), cancelAnimationFrame(i), G(!0);
      };
      return r.createElement(
        "div",
        {
          className: "slider__wrapper",
          ref: K,
          style: { cursor: W ? "ew-resize" : "default" },
        },
        null !== V &&
          r.createElement(
            r.Fragment,
            null,
            r.createElement(
              "div",
              { className: "slider__container" },
              r.createElement("img", {
                alt: c,
                src: n,
                width: Y.width,
                height: Y.height,
                onLoad: function() {
                  O && O(), ne(!0);
                },
                onError: function() {
                  A && A();
                },
              }),
              P &&
                !ee &&
                (F
                  ? r.createElement(
                      "div",
                      {
                        className: "custom-placeholder__wrapper",
                        style: { left: V },
                      },
                      F,
                    )
                  : r.createElement("div", { className: "placeholder" })),
              N &&
                r.createElement(
                  "div",
                  { className: "label__text label__right" },
                  N,
                ),
            ),
            r.createElement(
              "div",
              {
                className: "slider__container img-comp-overlay",
                style: { width: V <= 0 ? 0 : V },
              },
              r.createElement("img", {
                alt: s,
                src: t,
                width: Y.width,
                height: Y.height,
                onLoad: function() {
                  T && T(), oe(!0);
                },
                onError: function() {
                  R && R();
                },
              }),
              P &&
                !re &&
                (F
                  ? r.createElement(
                      "div",
                      { className: "custom-placeholder__wrapper" },
                      F,
                    )
                  : r.createElement("div", { className: "placeholder" })),
              k &&
                r.createElement(
                  "div",
                  { className: "label__text label__left" },
                  k,
                ),
            ),
            r.createElement(
              "div",
              {
                className: "slider__stick",
                style: { left: V, backgroundColor: f, width: m },
                onMouseDown: ae,
                onTouchStart: ae,
              },
              r.createElement(
                "div",
                { className: "slider__handle" },
                S
                  ? C || r.createElement(a, { backgroundColor: y, color: E })
                  : null,
              ),
            ),
          ),
      );
    }
    t.d(n, "default", function() {
      return c;
    });
  },
]);
